var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "_component-icon-svg",
      style: _vm.componentStyle,
      attrs: { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_287_407)" } }, [
        _c("path", {
          attrs: {
            d:
              "M10 11C12.7614 11 15 8.76142 15 6C15 3.23858 12.7614 1 10 1C7.23858 1 5 3.23858 5 6C5 8.76142 7.23858 11 10 11Z",
            stroke: _vm.strokeColor,
            "stroke-width": "2"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M10 32C14.9706 32 19 27.9706 19 23C19 18.0294 14.9706 14 10 14C5.02944 14 1 18.0294 1 23C1 27.9706 5.02944 32 10 32Z",
            stroke: _vm.strokeColor,
            "stroke-width": "2"
          }
        })
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_287_407" } }, [
          _c("rect", { attrs: { width: "20", height: "20", fill: "white" } })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }